import {
  Collapse,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Text,
  useBoolean,
  VStack
} from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { ClientEditableMenu } from 'src/components/common/Forms/ClientEditableMenu'
import { FormSelect } from 'src/components/common/Forms/FormSelect'
import { FormTextInput } from 'src/components/common/Forms/FormTextInput'
import {
  honorificPersonInChargeTitles,
  honorificTitles
} from 'src/hooks/invoice/useInvoices'
import {
  Honorific,
  PersonInChargeHonorific
} from 'src/interfaces/api/PostClients'
import { InvoiceFormInputs } from '../InvoiceEditForm'
import InvoiceEditorSection from '../InvoiceEditorSection'

export const InvoiceClient = () => {
  const { setValue, watch } = useFormContext<InvoiceFormInputs>()

  const [isShowAll, { toggle: toggleIsShowAll }] = useBoolean()
  const client = watch('client')

  return (
    <InvoiceEditorSection title="取引先の情報" number={1}>
      <HStack>
        <FormControl isRequired w="320px">
          <FormLabel>会社名・屋号名</FormLabel>
          <ClientEditableMenu
            currentClientId={client?.id}
            onSelectClient={(client) => client && setValue('client', client)}
          />
        </FormControl>
        <FormSelect<InvoiceFormInputs, Honorific>
          valueAsNumber
          w="100px"
          label="敬称"
          name="client.honorific"
        >
          {honorificTitles.map((title, i) => (
            <option key={`honorificTitles-${i}`} value={title.value}>
              {title.label}
            </option>
          ))}
        </FormSelect>
      </HStack>
      <Collapse in={isShowAll}>
        <VStack spacing="16px" mt="16px" align="stretch">
          <FormControl w="320px">
            <FormTextInput<InvoiceFormInputs>
              w="320px"
              placeholder="例）経営企画部"
              label="部署名"
              name="client.department_name"
            />
          </FormControl>
          <Flex gap="8px" align="center">
            <FormTextInput<InvoiceFormInputs>
              w="320px"
              label="担当者名"
              name="client.person_in_charge"
              placeholder="例）山田 太郎"
            />
            <FormSelect<InvoiceFormInputs, PersonInChargeHonorific>
              valueAsNumber
              w="100px"
              label="敬称"
              name="client.person_in_charge_honorific"
            >
              {honorificPersonInChargeTitles.map((title, i) => (
                <option
                  key={`modalHonorificPersonInChargeTitles-${i}`}
                  value={title.value}
                >
                  {title.label}
                </option>
              ))}
            </FormSelect>
          </Flex>
        </VStack>
      </Collapse>
      <Text
        mt="16px"
        display="inline-block"
        color="primary.purple"
        textDecoration="underline"
        fontSize="12px"
        lineHeight={1}
        fontWeight={700}
        cursor="pointer"
        onClick={toggleIsShowAll}
      >
        {isShowAll ? '詳細情報を隠す' : '詳細情報を表示'}
      </Text>
    </InvoiceEditorSection>
  )
}
